import { TimesHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetReportForAdminData = (reportId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const reportIdForUrl = reportId ? encodeURIComponent(reportId) : 'NaN';
    const url = `/Report/AdminReport/${reportIdForUrl}`;
    TimesHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isObjLoading: false,
          message: message
        });
      });
  }
};

export default GetReportForAdminData;